import React, { createContext, useContext, useEffect, useState } from 'react';
import {
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  StatArrow,
  StatGroup,
  Card,
  useColorModeValue,
  CardBody,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Spinner,
  Image,
  Text,
  Box,
} from '@chakra-ui/react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const Home = () => {
  useEffect(() => {
    try {
      fetchlastVideos();
      fetchVideos();
      fetchFollowerCount();
    } catch (error) {
      console.error(error);
    } finally {
      // setRefreshing(false); // Ensure refreshing is set to false after the data fetching
    }

    return () => {
      // cleanup logic if needed
    };
  }, []);

  const [loading, setLoading] = useState(true);
  const [videos, setVideos] = useState([]);
  const [lastvideos, setLastVideos] = useState([]);
  const [isLoading, setinloading] = useState(true);

  const fetchVideos = async () => {
    try {
      // Try to retrieve cached videos from local storage
      const cachedVideos = await localStorage.getItem('videos');
      if (cachedVideos !== null) {
        try {
          const parsedVideos = JSON.parse(cachedVideos);
          setVideos(Array.isArray(parsedVideos) ? parsedVideos : []);
        } catch (e) {
          console.error('Error parsing cached videos:', e);
          setVideos([]); // Fallback to empty array if parsing fails
        }
      }

      const token = await localStorage.getItem('accessToken');

      const response = await fetch('https://api.wipe.wtf/videos', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch videos');
      }

      const videosJson = await response.json();

      // Ensure the response is an array before setting state
      setVideos(Array.isArray(videosJson) ? videosJson : []);

      // Update local storage only if fetch is successful
      await localStorage.setItem('videos', JSON.stringify(videosJson));

      // Calculate total interactions and likes after setting videos
      const totalInteractionsCount = videosJson.reduce(
        (acc, video) => acc + video.Likes + video.Dislikes,
        0
      );
      const totalLikesCount = videosJson.reduce(
        (acc, video) => acc + video.Likes,
        0
      );

      setTotalInteractions(totalInteractionsCount.toLocaleString('de-DE'));
      setTotalLikes(totalLikesCount.toLocaleString('de-DE'));
    } catch (error) {
      console.error('Error fetching videos:', error);
      setVideos([]); // Fallback to empty array if error occurs
    } finally {
      setinloading(false);
    }
  };

  const fetchlastVideos = async () => {
    try {
      const cachedVideos = await localStorage.getItem('videos');
      if (cachedVideos !== null) {
        setVideos(JSON.parse(cachedVideos));
      }

      const token = await localStorage.getItem('accessToken');

      const response = await fetch('https://api.wipe.wtf/last-video', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch videos');
      }

      const videosJson = await response.json();
      setLastVideos(videosJson);

      await localStorage.setItem('videos', JSON.stringify(videosJson));
    } catch (error) {
      console.error('Error fetching videos:', error);
    } finally {
      setLoading(false);
    }
  };

  const [totalInteractions, setTotalInteractions] = useState(0);
  const [totalLikes, setTotalLikes] = useState(0);

  const fetchFollowerCount = async () => {
    try {
      const token = await localStorage.getItem('accessToken');
      const response = await fetch(`https://api.wipe.wtf/follower-count/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      setFollowerCount(data.followerCount.toLocaleString('de-DE'));
    } catch (error) {
      console.log(error);
    }
  };
  const [followerCount, setFollowerCount] = useState('Loading...');

  return (
    <div style={{ padding: 12 }}>
      <Card
        bg={useColorModeValue('#f0eded', '#0f0f0f')}
        style={{ borderRadius: 15, height: '12vh' }}
      >
        <CardBody style={{ paddingLeft: 34 }}>
          <StatGroup style={{}}>
            <Stat>
              <StatLabel>Followers:</StatLabel>
              <StatNumber>{followerCount}</StatNumber>
              <StatHelpText></StatHelpText>
            </Stat>

            <Stat>
              <StatLabel>Likes:</StatLabel>
              <StatNumber>{totalLikes}</StatNumber>
              <StatHelpText></StatHelpText>
            </Stat>
            <Stat>
              <StatLabel>Views:</StatLabel>
              <StatNumber>{totalInteractions}</StatNumber>
              <StatHelpText></StatHelpText>
            </Stat>
          </StatGroup>
        </CardBody>
      </Card>
      <Card
        bg={useColorModeValue('#f0eded', '#0f0f0f')}
        style={{
          borderRadius: 15,
          marginTop: 20,
          height: '50vh',
          minHeight: 400,
        }}
      >
        <CardBody>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              height: '100%',
            }}
          >
            {isLoading ? (
              <Skeleton
                width={220}
                height={'100%'}
                borderRadius={20}
                style={{ marginRight: 16 }}
                baseColor="#e0e0e0" // Custom background color
                highlightColor="#f0f0f0" // Custom highlight color
              />
            ) : (
              <Image
                src={`https://api.wipe.wtf/thumbnails/${lastvideos.thumbnail}`}
                height={'100%'}
                objectFit="cover"
                borderRadius={20}
                style={{ marginRight: 16 }}
              />
            )}
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                width: '100%',
              }}
            >
              <Text style={{ marginBottom: 8 }}>
                {isLoading ? (
                  <Skeleton
                    width={150}
                    baseColor="#e0e0e0" // Custom background color
                    highlightColor="#f0f0f0" // Custom highlight color
                  />
                ) : (
                  ''
                )}
              </Text>

              <Stat>
                <StatLabel>Title:</StatLabel>
                <StatNumber>
                  {isLoading ? (
                    <Skeleton
                      width={120}
                      baseColor="#e0e0e0" // Custom background color
                      highlightColor="#f0f0f0" // Custom highlight color
                    />
                  ) : (
                    lastvideos.Name
                  )}
                </StatNumber>
              </Stat>

              <Stat>
                <StatLabel>Likes:</StatLabel>
                <StatNumber>
                  {isLoading ? (
                    <Skeleton
                      width={80}
                      baseColor="#e0e0e0" // Custom background color
                      highlightColor="#f0f0f0" // Custom highlight color
                    />
                  ) : (
                    lastvideos.Likes
                  )}
                </StatNumber>
                <StatHelpText>
                  <StatArrow
                    type={
                      lastvideos.likeChangePercentage &&
                      lastvideos.likeChangePercentage < 0
                        ? 'decrease'
                        : 'increase'
                    }
                  />
                  {isLoading ? (
                    <Skeleton
                      width={50}
                      baseColor="#e0e0e0" // Custom background color
                      highlightColor="#f0f0f0" // Custom highlight color
                    />
                  ) : (
                    lastvideos.likeChangePercentage + '% to last video'
                  )}
                </StatHelpText>
              </Stat>

              <Stat>
                <StatLabel>Dislikes:</StatLabel>
                <StatNumber>
                  {isLoading ? (
                    <Skeleton
                      width={80}
                      baseColor="#e0e0e0" // Custom background color
                      highlightColor="#f0f0f0" // Custom highlight color
                    />
                  ) : (
                    lastvideos.Dislikes
                  )}
                </StatNumber>
                <StatHelpText>
                  <StatArrow
                    type={
                      lastvideos.dislikeChangePercentage &&
                      lastvideos.dislikeChangePercentage < 0
                        ? 'decrease'
                        : 'increase'
                    }
                  />
                  {isLoading ? (
                    <Skeleton
                      width={50}
                      baseColor="#e0e0e0" // Custom background color
                      highlightColor="#f0f0f0" // Custom highlight color
                    />
                  ) : (
                    lastvideos.dislikeChangePercentage + '% to last video'
                  )}
                </StatHelpText>
              </Stat>
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default Home;
